import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import CashRegisterDetail from "./cash-register-detail";

const CashRegisterDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/cashregisters');
    }

    return (
        <CashRegisterDetail id={id} onClose={onClose}/>
    )

});

export default CashRegisterDetailPage;